export default {"src":"/_next/static/media/KOS.4e117154.svg","height":18,"width":18};